import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../environments/environment';
import { UserRoleService } from '../../services/user-role.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private hasHandledSessionError = false;

  constructor(
    private messageService: MessageService,
    private auth: AuthService,
    private userRoleService: UserRoleService,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (
          error instanceof HttpErrorResponse &&
          (error.status === 401 || error.status === 403) &&
          req.url.startsWith(environment.backend.baseUrl) &&
          !this.hasHandledSessionError
        ) {
          this.hasHandledSessionError = true;

          this.messageService.add({
            severity: 'warn',
            summary: 'Sessione non valida',
            detail:
              'La tua sessione non è più valida o appartiene a un tenant diverso. Per continuare, effettua nuovamente il login.',
            life: 10000,
          });

          // Forza un logout completo in Auth0 così al prossimo accesso si rifà il login
          this.auth.logout({
            logoutParams: {
              returnTo: globalThis.location.origin,
              federated: true,
            },
          });
        }

        return throwError(() => error);
      }),
    );
  }
}
